<template>
  <div class="message-form-container">
    <div class="message-form-card">
      <div class="form-header">
        <h2>在线留言填写</h2>
      </div>

      <form @submit.prevent="submitMessage" class="message-form">
        <div class="form-group">
          <label for="projectName">项目名称 <span class="required">*</span></label>
          <el-select
            id="projectName"
            v-model="formData.projectName"
            placeholder="请选择项目"
            clearable
            style="width: 100%;"
          >
            <el-option
              v-for="project in projects"
              :key="project.id"
              :label="project.name"
              :value="project.name"
            />
          </el-select>
        </div>

        <div class="form-group">
          <label for="projectName">媒体名称 <span class="required">*</span></label>
          <el-select
              id="projectName"
              v-model="formData.media"
              placeholder="请选择项目"
              clearable
              style="width: 100%;"
          >
            <el-option
                v-for="media in medias"
                :key="media.id"
                :label="media.name"
                :value="media.name"
            />
          </el-select>
        </div>


        <div class="form-group">
          <label for="messageName">姓名</label>
          <input 
            id="messageName" 
            v-model="formData.messageName" 
            type="text" 
            placeholder="请输入您的姓名"
            class="form-input"
          />
        </div>

        <div class="form-group">
          <label for="messagePhone">联系方式 <span class="required">*</span></label>
          <input 
            id="messagePhone" 
            v-model="formData.messagePhone" 
            type="tel" 
            required
            placeholder="请输入您的手机号码"
            class="form-input"
          />
        </div>

        <div class="form-group">
          <label for="messageAddress">地址 <span class="required">*</span></label>
          <input 
            id="messageAddress" 
            v-model="formData.messageAddress" 
            type="text" 
            required
            placeholder="请输入您的地址"
            class="form-input"
          />
        </div>

        <div class="form-group">
          <label for="message">留言内容</label>
          <textarea 
            id="message" 
            v-model="formData.message" 
            rows="4"
            placeholder="请输入您的留言内容"
            class="form-textarea"
          ></textarea>
        </div>

        <div class="form-actions">
          <button type="submit" class="submit-btn" :disabled="isSubmitting">
            {{ isSubmitting ? '提交中...' : '提交留言' }}
          </button>
          <button type="button" class="reset-btn" @click="resetForm">
            重置
          </button>
        </div>
      </form>

      <div v-if="submitResult" class="submit-result" :class="submitResult.type">
        {{ submitResult.message }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'MessageForm',
  data() {
    return {
      projects: [],
      medias: [],
      formData: {
        projectName: '',
        messageName: '',
        messagePhone: '',
        messageAddress: '',
        message: '',
        media: '',
      },
      isSubmitting: false,
      submitResult: null
    };
  },
  async created() {
    await this.fetchProjects();
    await this.fetchAllMediaNames();
  },
  methods: {
    async fetchProjects() {
      try {
        // 获取用户信息
        const userInfoRes = await axios.get('/api/user/info');
        const userInfo = userInfoRes.data;
        const authority = userInfo.authority;
        const employeeId = userInfo.employeeId;
        
        let url;
        if (authority == 1) {
          url = `/api/projects`;
        } else {
          url = `/api/projects/byEmployee?employeeId=${employeeId}`;
        }
        const response = await axios.get(url);
        this.projects = response.data.data || [];
      } catch (error) {
        console.error('获取项目列表失败:', error);
        this.submitResult = {
          type: 'error',
          message: '获取项目列表失败，请刷新页面重试'
        };
      }
    },
    async fetchAllMediaNames() {
      try {
        const url = `/api/media`;
        const res = await axios.get(url);

        console.log(res);
        // 提取 name 和 type
        this.medias = res.data || [];

      } catch (e) {
        this.medias = [];
      }
    },
    async submitMessage() {
      if (!this.validateForm()) {
        return;
      }

      this.isSubmitting = true;
      this.submitResult = null;

      try {
        const now = new Date();
        const pad = n => n < 10 ? '0' + n : n;
        const nowStr = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}:00`;

        console.log(this.formData.media);
        const payload = {
          projectName: this.formData.projectName,
          messageName: this.formData.messageName,
          messagePhone: this.formData.messagePhone,
          messageAddress: this.formData.messageAddress,
          message: this.formData.message,
          mediaName: this.formData.media == undefined || this.formData.media == "" ? null : this.formData.media,
          messageTime: nowStr,
        };

        console.log(payload);

        const response = await axios.post('/api/messages/add', payload);
        
        if (response.data && response.data.success) {
          this.submitResult = {
            type: 'success',
            message: response.data.message
          };
          //this.resetForm();
          // 导入完成后自动跳转到留言管理页面
      setTimeout(() => {
        this.$router.push('/app/messages');
      }, 1500);
        } else {
          this.submitResult = {
            type: 'error',
            message: response.data.message
          };
        }
      } catch (error) {
        console.error('提交留言失败:', error);
        this.submitResult = {
          type: 'error',
          message: '网络错误，请检查网络连接后重试'
        };
      } finally {
        this.isSubmitting = false;
      }
    },
    validateForm() {
      if (!this.formData.projectName) {
        this.submitResult = {
          type: 'error',
          message: '请选择项目名称'
        };
        return false;
      }
      if (!this.formData.messagePhone.trim()) {
        this.submitResult = {
          type: 'error',
          message: '请输入联系方式'
        };
        return false;
      }
      // 姓名和留言内容可以为空，不做校验
      return true;
    },
    resetForm() {
      this.formData = {
        projectName: '',
        messageName: '',
        messagePhone: '',
        messageAddress: '',
        message: ''
      };
      this.submitResult = null;
    }
  }
};
</script>

<style scoped>
.message-form-container {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: calc(100vh - 60px);
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.message-form-card {
  width: 100%;
  max-width: 600px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 30px 40px;
}

.form-header {
  text-align: center;
  margin-bottom: 30px;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 20px;
}

.form-header h2 {
  color: #333;
  margin: 0 0 10px 0;
  font-size: 24px;
}

.form-header p {
  color: #666;
  margin: 0;
  font-size: 14px;
}

.message-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.required {
  color: #ff4d4f;
}

.form-input,
.form-select,
.form-textarea {
  padding: 12px 16px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.form-input:focus,
.form-select:focus,
.form-textarea:focus {
  outline: none;
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.form-textarea {
  resize: vertical;
  min-height: 100px;
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 10px;
}

.submit-btn,
.reset-btn {
  flex: 1;
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.submit-btn {
  background: #1890ff;
  color: white;
}

.submit-btn:hover:not(:disabled) {
  background: #40a9ff;
}

.submit-btn:disabled {
  background: #b2d8ff;
  cursor: not-allowed;
}

.reset-btn {
  background: #f5f5f5;
  color: #666;
  border: 1px solid #d9d9d9;
}

.reset-btn:hover {
  background: #e6e6e6;
  border-color: #bfbfbf;
}

.submit-result {
  margin-top: 20px;
  padding: 12px 16px;
  border-radius: 6px;
  text-align: center;
  font-size: 14px;
}

.submit-result.success {
  background-color: #f6ffed;
  border: 1px solid #b7eb8f;
  color: #52c41a;
}

.submit-result.error {
  background-color: #fff2f0;
  border: 1px solid #ffccc7;
  color: #ff4d4f;
}

@media (max-width: 768px) {
  .message-form-card {
    margin: 10px;
    padding: 20px;
  }
  
  .form-actions {
    flex-direction: column;
  }
}
</style> 